export default "<div id=\"footer\" class=\"footer\">\n\n  <span class=\"pull-left\">\n    © Amend 2018-{{ vm.now | date: 'yyyy'}}\n  </span>\n\n</div>\n";